import React from "react";

function Footer() {

    return (
        <footer class="footer footer-center p-10 rounded font-quicksand pt-10">
            <div>
                <div className="grid grid-flow-col gap-2">
                    <div className="grid grid-flow-col gap-2">
                        <a href="https://www.facebook.com/willowclothingmm">Facebook |</a>
                        <a href="https://instagram.com/willowclothingmm?igshid=YmMyMTA2M2Y=">Instagram |</a>
                        <a href="https://willowlabelmm.com/">Youtube |</a>
                    </div>
                </div>
                <div className="pt-8">
                    <p>Copyright © {(new Date().getFullYear())}. Eternal Gosh Band.</p>
                </div>
            </div>
        </footer>
    );

}

export default Footer;